import { useTranslation } from 'react-i18next'
import { FileText } from 'lucide-react'
import { formatAbsoluteDate, formatRelativeDate } from '../lib/timelineDate'
import { TimelineRow } from './TimelineRow'

interface TimelineOpeningProps {
  createdAt: string
  /** Lo que reportó el cliente. Puede venir vacío: el ticket no la exige. */
  description?: string | null
  withRail?: boolean
}

/**
 * Primer nodo del riel: la apertura del ticket. La descripción deja de ser un
 * bloque gris suelto por encima de la conversación y pasa a ser el ORIGEN de la
 * historia. El autor no se rotula: el detalle del portal no expone quién creó
 * el ticket y no se inventa.
 */
export function TimelineOpening({
  createdAt,
  description,
  withRail = true,
}: TimelineOpeningProps) {
  const { t, i18n } = useTranslation()

  const marker = (
    <span className="grid size-8 place-items-center rounded-full bg-neutral-100 text-ink-muted ring-4 ring-white">
      <FileText className="size-4" />
    </span>
  )

  return (
    <TimelineRow marker={marker} withRail={withRail}>
      <p className="text-xs text-ink-muted">
        <span className="font-semibold text-ink">
          {t('tickets.detail.opened')}
        </span>{' '}
        <time dateTime={createdAt} title={formatAbsoluteDate(createdAt)}>
          · {formatRelativeDate(createdAt, i18n.language)}
        </time>
      </p>
      {description && (
        <p className="mt-1.5 whitespace-pre-wrap break-words rounded-lg border border-black/5 bg-neutral-50 p-3 text-sm">
          {description}
        </p>
      )}
    </TimelineRow>
  )
}
